import React from "react";
import PropTypes from "prop-types";
import "../../css/Cards/CardChronique.css";
import Image from "../ImageElement";
import ChevronUp from "../../svg/ICON_chevronUP_Dark.svg";
import ChevronDown from "../../svg/ICON_chevronDown_Dark.svg";

/**
 * CardChronique component
 */
class CardChronique extends React.Component {
  static displayName = "CardChronique";
  static propTypes = {
    className: PropTypes.string,
    chronique: PropTypes.object.isRequired,
    screen: PropTypes.string.isRequired,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "CardChronique";
    this.maxLen = 300;

    this.state = {
      open: false,
      isSmall:
        (props.chronique.Text === null || props.chronique.length === 0) &&
        props.chronique.sections().reduce((sum, x) => {
          return sum + x.images().size;
        }, 0) < 1,
    };
  }

  /**
   * @override
   */
  render() {
    if (!this.props.chronique) return false;
    const chronique = this.props.chronique;
    return (
      <div
        className={`${this.className} ${this.props.className || ""} ${
          this.state.open ? "open" : "close"
        }`}
      >
        <div className={`${this.className}__content`}>
          <div className={`${this.className}__images`}>
            <Image
              src={chronique.cover()[`${this.props.screen}_src`]}
              alt={chronique.cover().alt}
            />
            {this.props.screen === "desktop" &&
              chronique.sections().map((section) => {
                return (
                  <div className={`${this.className}__imgs`} key={section.ID}>
                    {section.images().map((image) => {
                      return (
                        <Image
                          className={
                            image.isLandscape ? "landscape" : "portrait"
                          }
                          key={image.ID}
                          src={image[`${this.props.screen}_src`]}
                          alt={image.alt}
                        />
                      );
                    })}
                  </div>
                );
              })}
          </div>
          <div className={`${this.className}__right`}>
            <div>
              <div className={`${this.className}__text`}>
                <h1
                  className={`${this.className}__title`}
                  dangerouslySetInnerHTML={{
                    __html: chronique.Title,
                  }}
                />
                <div
                  className={`${this.className}__html`}
                  dangerouslySetInnerHTML={{
                    __html: this.state.open
                      ? chronique.SummaryText + chronique.Text
                      : chronique.SummaryText,
                  }}
                />
              </div>
            </div>
            {this.props.screen === "mobile" && (
              <div className={`${this.className}__images`}>
                {chronique.sections().map((section) => {
                  return (
                    <div className={`${this.className}__imgs`} key={section.ID}>
                      {section.images().map((image) => {
                        return (
                          <Image
                            className={
                              image.isLandscape ? "landscape" : "portrait"
                            }
                            key={image.ID}
                            src={image[`${this.props.screen}_src`]}
                            alt={image.alt}
                          />
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            )}

            {!this.state.isSmall && (
              <div
                className={`${this.className}__close`}
                onClick={() => this.setState({ open: !this.state.open })}
              >
                {this.state.open ? "Fermer" : "Ouvrir"}
                <img
                  src={this.state.open ? ChevronUp : ChevronDown}
                  alt="Up"
                  className="icon"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default CardChronique;



// WEBPACK FOOTER //
// ./src/components/Cards/CardChronique.js